export default {
  current_account: 'Cuenta Corriente',
  savings_account: 'Cuenta Ahorro',
  view_account: 'Cuenta Vista'
};
